import { render, staticRenderFns } from "./index-sjzx.vue?vue&type=template&id=70783887&scoped=true&"
import script from "./index-sjzx.vue?vue&type=script&lang=js&"
export * from "./index-sjzx.vue?vue&type=script&lang=js&"
import style0 from "./index-sjzx.vue?vue&type=style&index=0&id=70783887&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70783887",
  null
  
)

export default component.exports